define(function(require) {
    const datagridfilterdisplayTemplate = require('./DataGridFilterDisplay.template.html');
    const BaseView = require('app/Base.view');
    const _ = require('underscore');
    const CC = require('CC');

    require('./DataGridFilterDisplay.css');

    const DataGridFilterDisplayView = BaseView.extend({
        template: _.template(datagridfilterdisplayTemplate),

        defaults: function() {
            return {
                clientId: CC.utils.getCurrentClientId()
            };
        },

        events: {
            'click .data-grid__pill-clear': 'onClear'
        },

        validation: [
            {
                name: 'collection',
                required: true
            },
            {
                name: 'model',
                required: true
            },
            {
                name: 'form',
                required: true
            }
        ],

        initialize: function(options) {
            this.validateProperties();
            this.listenTo(this.model, 'change', this.render);
        },

        render: function() {
            const html = _.mapObject(this.model?.toJSON() || {}, (value, key) => {
                if (!key) return '';

                const values = Array.isArray(value) ? value : [value].filter(Boolean);
                if (values.length === 0) return '';

                let html = '';
                for (const value of values) {
                    const entry = this.collection?.getFormattedParamValue(key, value);

                    if (!entry || !this.hasValue(value)) {
                        continue;
                    }

                    // When a param is set to its unset option (eg. all), hide it
                    if (this.model.get(key) === entry.unsetOption) {
                        continue;
                    }

                    const modelValue = this.getSummaryValue(entry, this.model);

                    try {
                        html += _.template(
                            /*template*/
                            `<div class="data-grid__filter-pill">
                                <div class="data-grid__pill-content" 
                                     data-param="${_.escape(key)}" 
                                     title="${_.escape(modelValue)}">
                                     ${_.escape(modelValue)}
                                </div>
                                ${
                                    entry.unsetOption && entry.unsetOption !== entry.id
                                        ? `<a data-param="${_.escape(key)}" 
                                         data-value="${_.escape(entry.id)}" 
                                         class='data-grid__pill-clear btn-link'>
                                         <i class="lotacon lotacon-close-line"/>
                                       </a>`
                                        : ''
                                }
                            </div>`
                        )({
                            formattedValue: modelValue,
                            paramName: key,
                            value: entry.id || '',
                            hasUnset: Boolean(entry.unsetOption && entry.unsetOption !== entry.id)
                        });
                    } catch (error) {
                        console.error('Error generating template:', error);
                        continue; // Skip this iteration on template error
                    }
                }
                return html;
            });

            this.$el.html(_.values(html).join(' '));

            return this;
        },

        getSummaryValue: function(entry, model) {
            if (!entry) return 'Unknown';

            try {
                const { attributes } = entry;
                const getValue = key => {
                    const value = attributes ? entry.get(key) : entry[key];
                    return value != null && _.isFunction(value) ? value(model) : value;
                };

                return getValue('summary') ?? getValue('name') ?? getValue('id') ?? 'Unknown';
            } catch (error) {
                console.error('Error getting summary', error);
                return 'Unknown';
            }
        },

        onClear: function(e) {
            const paramName = this.$(e.currentTarget).data('param');
            const value = this.$(e.currentTarget).data('value');
            const option = this.collection.getFormattedParamValue(paramName, value) || {};

            if (option.unsetOption === 'CLEAR') {
                if (_.isArray(this.model.get(paramName))) {
                    const filteredList = this.model.get(paramName).filter(paramValue => paramValue != value);
                    this.model.set(paramName, filteredList);
                } else {
                    this.model.unset(paramName);
                }
            } else {
                this.model.set(paramName, option.unsetOption);
            }
        }
    });

    return DataGridFilterDisplayView;
});
